import React, { useEffect } from 'react';

import { log } from '../../services/utils';

import { getDocs } from '../../api/nora/assistant';

import { useUIAction } from '../../contexts/UIContext';

import ManagementRouter from './ManagementRouter';
import TagModal from '../TagModal';

const ManagementPortal = () => {
	const { setDocs } = useUIAction();

	useEffect( () => {
		( async () => {
			try {
				const docs = await getDocs();

				setDocs( docs );
			} catch ( error ) {
				// handle
			}
		} )();
	}, [ setDocs ] );

	return (
		<>
			{ log( 'managementPortal' ) }
			<ManagementRouter />
			<TagModal />
		</>
	);
};

export default ManagementPortal;
